import { MarginPipelineRequest } from '../../models/contract-request/margin-pipeline-request.model';

export interface ContractRequestsSlice {
    marginPipelineRequests: MarginPipelineRequest[];
}

export const initialContractRequestsSlice: ContractRequestsSlice = {
    marginPipelineRequests: []
};
